import React, { Fragment, useState, useLayoutEffect, useContext } from "react";
import { Col } from "reactstrap";
import { AlignCenter } from "react-feather";
import { Link } from "react-router-dom";
import { Image } from "../../../AbstractElements";
import CustomizerContext from "../../../_helper/Customizer";
import NotificationSlider from "./NotificationSlider";

const Leftbar = () => {
  const { layoutURL, toggleSidebar } = useContext(CustomizerContext);
  const width = useWindowSize();

  function useWindowSize() {
    const [size, setSize] = useState(window.innerWidth);

    useLayoutEffect(() => {
      function updateSize() {
        setSize(window.innerWidth);

        if (window.innerWidth <= 1007) {
          toggleSidebar(true);
          const pageWrapper = document.querySelector(".page-wrapper");
          if (pageWrapper)
            pageWrapper.className = "page-wrapper compact-wrapper";
        } else {
          toggleSidebar(false);
        }
      }

      window.addEventListener("resize", updateSize);
      updateSize();
      return () => window.removeEventListener("resize", updateSize);
    }, []);

    return size;
  }

  const responsive_openCloseSidebar = () => {
    const pageHeader = document.querySelector(".page-header");
    const sidebarWrapper = document.querySelector(".sidebar-wrapper");
    const bgOverlay = document.querySelector(".bg-overlay1");
    const megaMenu = document.querySelector(".mega-menu-container");

    if (width <= 991) {
      const isClosed = sidebarWrapper?.classList.contains("close_icon");
      if (isClosed) {
        sidebarWrapper?.classList.remove("close_icon");
        pageHeader?.classList.remove("close_icon");
        bgOverlay?.classList.add("active");
        toggleSidebar(false);
      } else {
        sidebarWrapper?.classList.add("close_icon");
        pageHeader?.classList.add("close_icon");
        bgOverlay?.classList.remove("active");
        megaMenu?.classList.remove("d-block");
        toggleSidebar(true);
      }
    } else {
      const isClosed = sidebarWrapper?.classList.contains("close_icon");
      if (isClosed) {
        pageHeader?.classList.remove("close_icon");
        sidebarWrapper?.classList.remove("close_icon");
        toggleSidebar(false);
      } else {
        pageHeader?.classList.add("close_icon");
        sidebarWrapper?.classList.add("close_icon");
        megaMenu?.classList.remove("d-block");
        toggleSidebar(true);
      }
    }
  };

  return (
    <Fragment>
      <Col className="header-logo-wrapper col-auto p-0" id="out_side_click">
        <div className="logo-wrapper">
          <Link to={`${process.env.PUBLIC_URL}/pages/sample-page/${layoutURL}`}>
            <Image
              attrImage={{
                className: "img-fluid for-light",
                src: require("../../../assets/images/logo/logo.png"),
                alt: "Logo",
              }}
            />
            <Image
              attrImage={{
                className: "img-fluid for-dark",
                src: require("../../../assets/images/logo/logo_dark.png"),
                alt: "Logo Dark",
              }}
            />
          </Link>
        </div>
        <div
          className="toggle-sidebar"
          onClick={() => responsive_openCloseSidebar()}
          style={{ display: width <= 991 ? "block" : "none" }}
        >
          <AlignCenter
            className="status_toggle middle sidebar-toggle"
            id="sidebar-toggle"
          />
        </div>
      </Col>
      <Col xxl="5" xl="6" lg="5" md="4" sm="3" className="left-header p-0">
        {/* <NotificationSlider /> */}
      </Col>
    </Fragment>
  );
};

export default Leftbar;
